<div class="group editable-side-panel-input-textual"
  [formGroup]="getFormGroup()"
  [class]="subtype"
  [class.hasValue]="hasValue()"
  [class.hasError]="getErrorMessage()"
  [class.hasBeenEdited]="hasBeenEdited()">

  <!-- OPTIONAL ICON -->
  @if (reservePrefixIconWhitespace) {
    <div class="icon-wrapper">
      @if (iconName) {
        <mat-icon
          [svgIcon]="iconName">
        </mat-icon>
      }
    </div>
  }

  <!-- MAT FORM FIELDS -->

  <!-- nested form groups of type `text` like `coordinateImport.latitude` -->
  @if (subtype === 'text' && formGroupNameRef) {
    <div [formGroupName]="formGroupNameRef"
      class="w-full flex">
      <mat-form-field appearance="fill">
        <mat-label>{{getLabel()}}</mat-label>
        @if (subtype === 'text') {
          <input
            [type]="htmlType"
            matInput
            appGxInput
            [formControlName]="fieldId">
        }
        @if (getErrorMessage()) {
          <mat-icon svgIcon="error" class="error-suffix-icon"></mat-icon>
        }
        @if (getErrorMessage()) {
          <mat-error>{{getErrorMessage()}}</mat-error>
        }
      </mat-form-field>
    </div>
  }

  <!-- non-nested form groups -->

  <!-- TEXT -->
  @if (subtype === 'text' && !formGroupNameRef) {
    <mat-form-field
      appearance="fill">
      <mat-label>{{getLabel()}}</mat-label>
      @if (subtype === 'text') {
        <input
          [type]="htmlType"
          matInput appGxInput
          [formControlName]="fieldId">
      }
      @if (getErrorMessage()) {
        <mat-icon svgIcon="error" class="error-suffix-icon"></mat-icon>
      }
      @if (getErrorMessage()) {
        <mat-error>{{getErrorMessage()}}</mat-error>
      }
    </mat-form-field>
  }

  <!-- TEXTAREA -- COMMENT -->
  @if (subtype === 'comment') {
    <mat-form-field
      appearance="fill">
      <mat-label>{{getLabel()}}</mat-label>
      <textarea #textarea
        matInput
        appGxInput
        appDblClickPrependToday
        [formControlName]="fieldId"
        [cdkTextareaAutosize]="hasValue()"
      cdkAutosizeMinRows="1"></textarea>
      @if (getErrorMessage()) {
        <mat-icon svgIcon="error" class="error-suffix-icon"></mat-icon>
      }
      @if (getErrorMessage()) {
        <mat-error>{{getErrorMessage()}}</mat-error>
      }
    </mat-form-field>
  }

  <!-- TEXTAREA -- MULTILINE_TEXT -->
  @if (subtype === 'multiline_text') {
    <mat-form-field
      appearance="fill">
      <mat-label>{{getLabel()}}</mat-label>
      <textarea #textarea
        matInput
        appGxInput
        [cdkTextareaAutosize]="hasValue()"
        cdkAutosizeMinRows="1"
      [formControlName]="fieldId"></textarea>
      @if (getErrorMessage()) {
        <mat-icon svgIcon="error" class="error-suffix-icon"></mat-icon>
      }
      @if (getErrorMessage()) {
        <mat-error>{{getErrorMessage()}}</mat-error>
      }
    </mat-form-field>
  }

  <!-- TEXTAREA -- link -->
  @if (subtype === 'link' && !formGroupNameRef) {
    <mat-form-field
      appearance="fill">
      <mat-label>{{getLabel()}}</mat-label>
      <textarea #textarea
        matInput
        appGxInput
        [cdkTextareaAutosize]="hasValue()"
        cdkAutosizeMinRows="1"
      [formControlName]="fieldId"></textarea>
      @if (getErrorMessage()) {
        <mat-icon svgIcon="error" class="error-suffix-icon"></mat-icon>
      }
      @if (getErrorMessage()) {
        <mat-error>{{getErrorMessage()}}</mat-error>
      }
    </mat-form-field>
  }

  <!-- TEXTAREA -- social media link -->
  @if (subtype === 'link' && formGroupNameRef) {
    <mat-form-field
      [formGroupName]="formGroupNameRef"
      appearance="fill">
      <mat-label>{{getLabel()}}</mat-label>
      <textarea #textarea
        matInput
        appGxInput
        [cdkTextareaAutosize]="hasValue()"
        cdkAutosizeMinRows="1"
      [formControlName]="fieldId"></textarea>
      @if (getErrorMessage()) {
        <mat-icon svgIcon="error" class="error-suffix-icon"></mat-icon>
      }
      @if (getErrorMessage()) {
        <mat-error>{{getErrorMessage()}}</mat-error>
      }
    </mat-form-field>
  }

  @if (subtype === 'link') {
    <a
      mat-icon-button
      class="linkIcon ml-1 -mr-2 invisible group-hover:visible"
     [ngStyle]="{
            'color': isValueAnUrl() ? 'var(--neutral-10)' : 'var(--neutral-60)'
          }"
      [disabled]="!isValueAnUrl()"
      (click)="goToLink()"
      appGtagEvent
      trackOn="click"
      action="open link"
      category="Navigation [overhaul]"
     [params]="{
        event_label: 'Open link/photo from location edit panel'
     }">
      <mat-icon svgIcon="open_in_new"></mat-icon>
    </a>
  }

  <!-- COPY TRIGGER -->
  <button mat-icon-button type="button" class="copyIcon ml-1 invisible group-hover:visible"
          [ngStyle]="{
            'color': hasValue() ? 'var(--neutral-10)' : 'var(--neutral-60)'
          }"
    [disabled]="!hasValue()"
    [matTooltip]="hasValue() ? 'Copy' : ''"
    matTooltipPosition="below"
    (click)="copyValue($event)">
    <mat-icon svgIcon="content_copy"></mat-icon>
  </button>

  <!-- JSON DATASOURCE CONNECTION -->
  <div class="dataSourceIcon-wrapper invisible group-hover:visible">
    @if (isFieldWithDataSource) {
      <mat-icon
        [svgIcon]="hasActiveConnection ? 'fiber_manual_record' : 'fiber_manual_record_outline'"
        [ngClass]="hasActiveConnection ? 'active' : 'inactive'"
        class="dataSourceIcon"
        matTooltip="{{ hasActiveConnection ?
                    ('ADDRESS_LIST.DATA_SOURCE_CONFIG.TOOLTIP.ACTIVE' | translate) :
                    ('ADDRESS_LIST.DATA_SOURCE_CONFIG.TOOLTIP.INACTIVE' | translate) }}"
        matTooltipPosition="below">
      </mat-icon>
    }
  </div>

</div>
